import segment_ids from '_constants/segment_ids.json'

// The Segment IDs dropdown offers the built-in mapping spaces (partner spaces,
// per-country hashes, "Use Segment Name as ID") plus any custom ID set
// generated from a distribution row. A set occupies its own mapping space on
// each audience - keyed by its `slug` - so it is added to the built-in list
// rather than replacing an entry in it.

export const buildSegmentIdOptions = (customIdSets = []) => [
  ...segment_ids.map((item) => ({ value: item.code, label: item.name })),
  ...customIdSets.map((set) => ({ value: set.slug, label: set.name })),
]

// Resolve a stored `mapping_ids` code to its display name. Custom sets are
// checked first: a set can only claim a space no built-in one holds, so the two
// never disagree, but checking the shorter list first keeps the newest naming
// authoritative if that ever changes.
//
// Returns undefined for an unknown code - callers fall back to `pretty()`.
export const getSegmentIdName = (customIdSets = [], code) =>
  customIdSets.find((set) => set.slug === code)?.name ??
  segment_ids.find((item) => item.code === code)?.name
